export default __webpack_public_path__ + "static/media/clipboard.2824c85c.svg";